import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { ContainerLoadingStatus, ContainerStatusEnum, BlStatusEnum, JobCompletedEnum, InsuranceType } from "@gtpl/shared-models/common-models";
import { ContainerLog } from "./container-log.entity";
@Entity('container')
export class Container {

  @PrimaryGeneratedColumn("increment", { name: 'container_id' })
  containerId: number;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "container_number"
  })
  containerNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "bl_no"
  })
  blNo: string;

  @Column("int", {
    nullable: true,
    name: "sale_order_id"
  })
  saleOrderId: number;
  @Column("int", {
    nullable: true,
    name: "insurance_id"
  })
  insuranceId: number;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "line_seal"
  })
  lineSeal: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "e_seal"
  })
  eSeal: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "scac"
  })
  scac: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "couriourNo"
  })
  couriourNo: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "booking_no"
  })
  bookingNo: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "bill_of_lading"
  })
  billOfLading: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "shipping_bill_no"
  })
  shippingBillNo: string;


  @Column({
    type: 'enum',
    enum: ContainerStatusEnum,
    nullable: false,
    name: 'status',
    default: ContainerStatusEnum.BOOKED
  })
  containerStatus: ContainerStatusEnum;
  @Column({
    type: 'enum',
    enum: InsuranceType,
    nullable: false,
    name: 'insurance_type',
    // default: InsuranceType.Internal
  })
  insuranceType: InsuranceType;
  @Column({
    type: 'enum',
    enum: JobCompletedEnum,
    nullable: false,
    name: 'doc_dispatch_status',
    // default: JobCompletedEnum.NO
  })
  documentDispatchStatus: JobCompletedEnum;

  @Column({
    type: 'enum',
    enum: ContainerLoadingStatus,
    nullable: false,
    name: 'loading_status',
    default: ContainerLoadingStatus.OPEN
  })
  loadingStatus: ContainerLoadingStatus;

  @Column({
    type: 'enum',
    enum: BlStatusEnum,
    nullable: false,
    name: 'bl_status',
    default: BlStatusEnum.NOT_RECEIVED
  })
  blStatus: BlStatusEnum;

  
  @Column({
    nullable: true,
    name: "expected_delivery_date"
  })
  expectedDeliveryDate: Date;
  @Column({
    nullable: true,
    name: "etd"
  })
  etd: Date;
  
  
  @Column("date", {
    nullable: true,
    name: "doc_dispatch_date"
  })
  documentDispatchDate: string;
  @Column("date", {
    nullable: true,
    name: "insurance_date"
  })
  insuranceDate: string;
  @Column({
    nullable: true,
    name: "obl_etd"
  })
  oblEtd: Date;

  @Column("date", {
    nullable: true,
    name: "ho_issued_date"
  })
  hoIssuedDate: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "reference_number"
  })
  referenceNumber: string; 
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "vc_no"
  })
  vcNo: string; 
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "hoCertificateNo"
  })
  hoCertificateNo: string; 
  

  @Column({
    nullable: true,
    name: "loading_date"
  })
  loadingDate: Date;
  @Column({
    nullable: true,
    name: "actual_date"
  })
  actualDate: Date;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "vehicle_number"
  })
  vehicleNumber: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "driver_name"
  })
  driverName: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "phone_number"
  })
  phoneNumber: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "assigned_by"
  })
  assignedBy: string;
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "tracking_no"
  })
  trackingNo: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "vessel_name"
  })
  vesselName: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "port_of_transhipment"
  })
  portOfTranshipment: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "referenceNo"
  })
  referenceNo: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "port_of_discharge"
  })
  portOfDischarge: string;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "importing_vessel_name"
  })
  importingVesselName: string;
  @Column("boolean", {
    nullable: false,
    name: "draft_received",
    default: false
})
draftReceived: boolean;

@Column("date", {
  nullable: true,
  name: "date_of_transhipment"
})
dateOfTranshipment: string;
@Column("date", {
  nullable: true,
  name: "shipped_onboard_date"
})
shippedOnboardDate: string;
@Column("date", {
  nullable: true,
  name: "discharge_date"
})
dischargeDate: string;
@Column("date", {
  nullable: true,
  name: "destination_date"
})
destinationDate: string;
  
  @Column("int", {
    nullable: true,
    name: "unit_id"
  })
  unitId: number;
  @Column("int", {
    nullable: true,
    name: "insurance_amount"
  })
  insuranceAmount: number;

   @Column("date", {
    nullable: true,
    name: "shipping_bill_date"
  })
  shippingBillDate:string;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type => ContainerLog, containerLog => containerLog.containerInfo)
  containerLogInfo: ContainerLog[];
}
